import { styled } from '@mui/material/styles';
import KModal from '../KModal/index.js';

var PREFIX = "KContactSheetsModal";
var classes = {
    formControl: "".concat(PREFIX, "-formControl")
};
var StyledKContactSheetsModal = styled(KModal)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.formControl)] = {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        _b);
});

export { classes, StyledKContactSheetsModal as default };
//# sourceMappingURL=index.styled.js.map
